var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('users-form',{attrs:{"user":_vm.user,"errors":_vm.errors},on:{"update:user":function($event){_vm.user=$event}}})],1):_c('loading-content')}
var staticRenderFns = []

export { render, staticRenderFns }